import React from 'react';
import { Box, Typography, Link, Container } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => (
  <Box
    component="footer"
    sx={{
      borderTop: '1px solid rgba(120,100,80,0.12)',
      py: 4,
      mt: 'auto',
    }}
  >
    <Container maxWidth="lg">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 2,
        }}
      >
        <Box>
          <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.25 }}>
            Fallon d&apos;Floor
          </Typography>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            Fan-made. Not affiliated with FIFA, UEFA, or the Ballon d&apos;Or.
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 3 }}>
          <Link
            component={RouterLink}
            to="/seasons"
            underline="none"
            sx={{ color: 'text.secondary', fontSize: '0.8rem', '&:hover': { color: 'text.primary' } }}
          >
            Previous Seasons
          </Link>
          <Link
            component={RouterLink}
            to="/privacy-policy"
            underline="none"
            sx={{ color: 'text.secondary', fontSize: '0.8rem', '&:hover': { color: 'text.primary' } }}
          >
            Privacy Policy
          </Link>

        </Box>
      </Box>
    </Container>
  </Box>
);

export default Footer;
